import hljs from 'highlight.js';
// import 'highlight.js/styles/default.css';
import 'highlight.js/styles/github.css'; // 引入主题
// import 'highlight.js/styles/vs2015.css';
// import 'highlight.js/styles/pojoaque.css';
// import 'highlight.js/styles/xcode.css';

import { marked } from 'marked';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import {proxy_pre} from './api_paths.js';


const { v4: uuidv4 } = require('uuid'); // 用于生成唯一ID

/**
 * 生成唯一的ID
 * @param {string} content - 标题内容
 * @returns {string} 唯一ID
 */
function generateUniqueId(content) {
  // 使用内容的哈希值 + 随机数确保唯一性
  let baseId = content
    .toLowerCase()
    .trim()
    .replace(/[^\w\s\u4e00-\u9fa5-]/g, '') // 移除特殊字符，保留中文
    .replace(/[\s_-]+/g, '-') // 将空格和下划线替换为连字符
    .replace(/^-+|-+$/g, ''); // 移除首尾连字符
  
  // 确保ID不以数字开头（CSS选择器要求）
  if (/^\d/.test(baseId)) {
    baseId = 'heading-' + baseId;
  }
  
  // 如果处理后为空，使用默认前缀
  if (!baseId) {
    baseId = 'heading';
  }
  
  return baseId + '-' + uuidv4().slice(0, 8);
}

/**
 * 提取HTML中的标题并添加ID
 * @param {string} html - HTML字符串
 * @returns {object} 包含处理后的HTML和标题信息的对象
 */
function extractAndTagHeaders(html) {
  const headers = [];
  let processedHtml = html;
  
  // 正则匹配所有标题标签
  const headerRegex = /<h([1-6])([^>]*)>(.*?)<\/h[1-6]>/gi;
  
  processedHtml = processedHtml.replace(headerRegex, (match, level, attrs, content) => {
    // 清理内容，移除HTML标签
    const cleanContent = content.replace(/<[^>]*>/g, '').trim();
    
    if (cleanContent) {
      const id = generateUniqueId(cleanContent);
      const headerInfo = {
        level: parseInt(level),
        content: cleanContent,
        id: id
      };
      
      headers.push(headerInfo);
      
      // 添加id属性到标题标签
      if (attrs.includes('id=')) {
        // 如果已有id属性，替换它
        attrs = attrs.replace(/id\s*=\s*["'][^"']*["']/i, `id="${id}"`);
      } else {
        // 如果没有id属性，添加它
        attrs = ` id="${id}"` + attrs;
      }
      
      return `<h${level}${attrs}>${content}</h${level}>`;
    }
    
    return match;
  });
  
  return {
    html: processedHtml,
    headers: headers
  };
}

/**
 * 构建目录树
 * @param {Array} headers - 标题数组
 * @returns {Array} 目录树结构
 */
function buildTOCTree(headers) {
  if (!headers.length) return [];
  
  const tocTree = [];
  const stack = [];
  
  headers.forEach(header => {
    const { level, content, id } = header;
    
    // 创建当前节点
    const node = {
      level: level,
      content: content,
      id: id,
      children: []
    };
    
    // 维护栈结构，确保层级关系正确
    while (stack.length > 0 && stack[stack.length - 1].level >= level) {
      stack.pop();
    }
    
    if (stack.length === 0) {
      // 根节点
      tocTree.push(node);
    } else {
      // 子节点
      stack[stack.length - 1].children.push(node);
    }
    
    stack.push(node);
  });
  
  return tocTree;
}

/**
 * 将目录树转换为HTML
 * @param {Array} tocTree - 目录树
 * @param {number} depth - 当前深度
 * @returns {string} HTML字符串
 */
function tocTreeToHTML(tocTree, depth = 0) {
  if (!tocTree.length) return '';
  
  let html = '<ul class="toc-list">\n';
  
  tocTree.forEach(node => {
    html += `  <li class="toc-item toc-level-${node.level}">\n`;
    html += `    <a href="#${node.id}" class="toc-link">${node.content}</a>\n`;
    
    if (node.children.length > 0) {
      html += `    ${tocTreeToHTML(node.children, depth + 1)}`;
    }
    
    html += '  </li>\n';
  });
  
  html += '</ul>\n';
  
  return html;
}

/**
 * 生成目录HTML
 * @param {Array} headers - 标题数组
 * @returns {string} 目录HTML
 */
function generateTOCHTML(headers) {
  const tocTree = buildTOCTree(headers);
  return tocTreeToHTML(tocTree);
}

/**
 * 主函数：为HTML添加目录
 * @param {string} html - 原始HTML
 * @param {string} tocPlaceholder - 目录占位符，默认为[TOC]
 * @returns {string} 处理后的HTML
 */
function addTOCToHTML(html, tocPlaceholder = '[TOC]') {
  // 1. 提取并标记标题
  const { html: taggedHtml, headers } = extractAndTagHeaders(html);
  
  // 2. 生成目录HTML
  const tocHTML = generateTOCHTML(headers);
  
  // 3. 插入目录到指定位置
  if (taggedHtml.includes(tocPlaceholder)) {
    return taggedHtml.replace(tocPlaceholder, tocHTML);
  } else {
    // 如果没有占位符，默认不插入目录
    return taggedHtml;
  }
}

// 注册 Vue 语言
hljs.registerLanguage('vue', function() {
    return {
      name: "Vue",
      subLanguage: "xml",
      contains: [
        {
          className: "tag",
          begin: /<\/?[a-z][\s\S]*>/,
        },
        // 添加更多 Vue 特有的高亮规则
      ],
    };
  });

function  setImgStyles() {
      // 直接通过 class 选择器查找 preview-content 容器
      const previewContentElements = document.querySelectorAll('.preview-content');
      
      if (previewContentElements.length > 0) {
        previewContentElements.forEach((previewElement) => {
          // 在每个 preview-content 容器中查找 img 元素
          const imgElements = previewElement.querySelectorAll('img');
          imgElements.forEach((img) => {
            img.style.maxWidth = '90%';
            img.style.height = 'auto';
            img.style.display = 'block';      // 可选：块级显示
            img.style.margin = '0 auto';      // 可选：水平居中
          });
        });
      }
    }

// 封装高亮函数
function highlightAllCode() {
    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(block => {
        // 检查元素是否已经高亮
        if (!block.dataset.highlighted) {
            hljs.highlightElement(block);
            // 标记元素已经高亮
            block.dataset.highlighted = 'true';
                        // 设置代码字体样式
            block.style.fontSize = '15px';      // 字体大小
            block.style.fontWeight = 'normal';  // 字体粗细：normal, bold, 或具体数值 400, 700 等
        } 
    });
}

function Render(input, userEmail) { // ⭐ 新增 userEmail 参数
  try {
    // ⭐ 先提取并处理数学公式，用占位符替换
    const formulaPlaceholders = [];
    let placeholderIndex = 0;

    // --- 处理块级公式 ---
    // 匹配 $$...$$
    input = input.replace(/\$\$([\s\S]*?)\$\$/g, (match, equation) => {
      try {
        const html = katex.renderToString(equation.trim(), {
          displayMode: true,
          throwOnError: false
        });
        const placeholder = `KATEX_PLACEHOLDER_BLOCK_${placeholderIndex}KATEX`;
        formulaPlaceholders[placeholderIndex] = html;
        placeholderIndex++;
        return placeholder;
      } catch (error) {
        console.error('块级公式 $$...$$ 渲染错误:', error);
        return match;
      }
    });

    // 匹配 \[...\] (注意：需要转义 [ 和 ])
    input = input.replace(/\\\[\s*([\s\S]*?)\s*\\\]/g, (match, equation) => {
      try {
        const html = katex.renderToString(equation.trim(), {
          displayMode: true, // \[ \] 也是块级公式
          throwOnError: false
        });
        const placeholder = `KATEX_PLACEHOLDER_BLOCK_${placeholderIndex}KATEX`;
        formulaPlaceholders[placeholderIndex] = html;
        placeholderIndex++;
        return placeholder;
      } catch (error) {
        console.error('\\[ \\] 块级公式渲染错误:', error);
        return match;
      }
    });

    // --- 处理行内公式 ---
    // 匹配 $...$
    input = input.replace(/\$(.+?)\$/g, (match, equation) => {
      try {
        const html = katex.renderToString(equation.trim(), {
          displayMode: false,
          throwOnError: false
        });
        const placeholder = `KATEX_PLACEHOLDER_INLINE_${placeholderIndex}KATEX`;
        formulaPlaceholders[placeholderIndex] = html;
        placeholderIndex++;
        return placeholder;
      } catch (error) {
        console.error('行内公式 $...$ 渲染错误:', error);
        return match;
      }
    });

    // 匹配 \(...\) (注意：需要转义 ( 和 ))
    input = input.replace(/\\\(\s*([^]*?)\s*\\\)/g, (match, equation) => {
      try {
        const html = katex.renderToString(equation.trim(), {
          displayMode: false, // \( \) 是行内公式
          throwOnError: false
        });
        const placeholder = `KATEX_PLACEHOLDER_INLINE_${placeholderIndex}KATEX`;
        formulaPlaceholders[placeholderIndex] = html;
        placeholderIndex++;
        return placeholder;
      } catch (error) {
        console.error('\\( \\) 行内公式渲染错误:', error);
        return match;
      }
    });

    
    // ⭐ 渲染 Markdown
    let html = marked(input);

    // ⭐ 将占位符替换回渲染好的数学公式 HTML
    for (let i = 0; i < placeholderIndex; i++) {
      const placeholderBlock = `KATEX_PLACEHOLDER_BLOCK_${i}KATEX`;
      const placeholderInline = `KATEX_PLACEHOLDER_INLINE_${i}KATEX`;
      const formulaHtml = formulaPlaceholders[i];
      
      // 替换块级公式占位符
      html = html.replace(placeholderBlock, formulaHtml);
      // 替换行内公式占位符
      html = html.replace(placeholderInline, formulaHtml);
    }

    // ⭐ 处理图片路径 (只处理以 / 开头的相对路径图片)
    html = html.replace(/<img[^>]*src=["']([^"']*)["'][^>]*>/g, (match, src) => {
      if (src.startsWith('/')) {
        // 以 / 开头 → 我服务器的资源，自动加前缀
        const encodedSrc = encodeImageUrl(src);  // 编码原始src
        const finalSrc = `${proxy_pre}/${userEmail}${encodedSrc}`;  // 添加前缀
        
        // 使用原始的match和src进行替换
        return match.replace(src, finalSrc);
      } else {
        // 其他情况（http、https、本地 file:// 等） → 不改动
        return match;
      }
    });
    let res = extractAndTagHeaders(html); // 返回被添加标题id后的html以及目录html
    html = res.html;
    let headers = res.headers;
    let toc = generateTOCHTML(headers);
    return {
      html : html,
      toc : toc
    }
  } catch (error) {
    console.error('渲染错误:', error);
    return {
      html : this.userInput, // 注意：这里 this 可能为 undefined，如果需要返回原始输入，应传入 input 或其他变量
      toc : ''
    }
  }
}

// 辅助函数：对图片URL进行编码
function encodeImageUrl(url) {
  // 如果URL包含协议（http://, https://等），需要特殊处理
  if (url.includes('://')) {
    // 分离协议和路径部分
    const protocolSplit = url.split('://');
    if (protocolSplit.length === 2) {
      const protocol = protocolSplit[0];
      const pathPart = protocolSplit[1];
      
      // 对路径部分进行编码处理
      const pathParts = pathPart.split('/');
      const encodedPathParts = pathParts.map(part => {
        if (part === '') return part;
        return encodeUrlComponent(part);
      });
      
      return protocol + '://' + encodedPathParts.join('/');
    }
  }
  
  // 对于没有协议的URL，直接按/分割处理
  const parts = url.split('/');
  const encodedParts = parts.map(part => {
    if (part === '') return part;
    return encodeUrlComponent(part);
  });
  
  return encodedParts.join('/');
}

// 辅助函数：编码URL组件中的特殊字符（不处理百分号，避免重复编码）
function encodeUrlComponent(component) {
  // 按照映射表进行编码（不包括百分号）
  const charMap = {
    '+': '%2B',
    ' ': '%20',
    '#': '%23',
    '&': '%26',
    '=': '%3D',
    '?': '%3F'
  };
  
  let encoded = component;
  
  // 逐字符检查和替换
  for (let char in charMap) {
    encoded = encoded.split(char).join(charMap[char]);
  }
  
  return encoded;
}

export {
    highlightAllCode,
    setImgStyles,
    addTOCToHTML,
    encodeImageUrl,
    Render
}